export const RETURN_BETA_FEATURES = {
  ENABLE_COVERGENIUS_INSURANCE: 'enable_covergenius_insurance',
  RETURN_PORTAL_LAYOUTS: 'return_portal_layouts',
  RETURNS_PORTAL_SETTINGS_TAB_DESIGN: 'returns_portal_design_settings_page',
  RETURN_REQUESTS: 'return_requests',
  RETURN_IMAGE_UPLOAD: 'return_portal_picture_upload',
}
